import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64f60b14"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "question-box"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question-box-seperator" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Login = _resolveComponent("Login")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_QuestionForm = _resolveComponent("QuestionForm")!
  const _component_Message = _resolveComponent("Message")!

  return (_ctx.newQuestionsEnabled)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (!_ctx.showQuestionForm)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openQuestionForm && _ctx.openQuestionForm(...args)))
              }, "Frage stellen"),
              _createVNode(_component_OverlayPanel, {
                ref: "loginOP",
                showCloseIcon: true,
                dismissable: true,
                appendTo: "body",
                class: "wdw-widgets"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Login, { domainid: _ctx.domainid }, null, 8, ["domainid"])
                ]),
                _: 1
              }, 512)
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_QuestionForm, {
                onCloseForm: _ctx.closeQuestionForm,
                onOpenQuestion: _ctx.openQuestion
              }, null, 8, ["onCloseForm", "onOpenQuestion"]),
              _hoisted_2
            ])),
        (_ctx.feedbackMessage.message !== '')
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 2,
              closable: "",
              class: "mb-2",
              role: "alert",
              severity: _ctx.feedbackMessage.type || 'info'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.feedbackMessage.message), 1)
              ]),
              _: 1
            }, 8, ["severity"]))
          : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}